export default "__VITE_ASSET__DIc_0zHc__"